import {React, useEffect} from 'react';
import {
  FaRedo,
  FaLink,
} from "react-icons/fa";
import workOne from "../assets/ii.jpg";
import workTwo from "../assets/p2.jpg";
// import workThree from "../assets/img-3.jpg";
// import workFour from "../assets/img-4.jpg";
function Portfolio() {

  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);

  return (
    <>
    <section className="portfolio">
        <h1 className="heading"> <span> my </span> work </h1>
        <div className="box-container">

          <div className="box">
            <img src={workOne} alt="firstWork" loading='lazy' />
            <div className="content">
              <h3>Technohacks-Internship</h3>
              <p>simple calculator using c language </p>
              <a href="https://www.linkedin.com/posts/sureka-kumar-26153532b_simple-calculator-using-c-language-activity-7245807533242617856-HV4M?utm_source=share&utm_medium=member_android&rcm=ACoAAFMxwikBDZbcDjTeGXFxMDw5NT2YysEeCcQ"> <FaLink/> Click Here  </a>
              <p>ATM simulator</p>
               <a href="https://www.linkedin.com/posts/sureka-kumar-26153532b_atm-simulator-using-c-language-activity-7245806526592876544--1t4?utm_source=share&utm_medium=member_android&rcm=ACoAAFMxwikBDZbcDjTeGXFxMDw5NT2YysEeCcQ"> <FaLink/> Click Here  </a>
               <p>Palindrome checker</p>
               <a href="https://www.linkedin.com/posts/sureka-kumar-26153532b_palindrome-checker-using-c-language-technohacks-activity-7245741725644722176-F3FM?utm_source=share&utm_medium=member_android&rcm=ACoAAFMxwikBDZbcDjTeGXFxMDw5NT2YysEeCcQ"> <FaLink/> Click Here  </a>
               <p>ongoing frontend developer-intership</p>
               <a href="https://www.linkedin.com/posts/sureka-kumar-26153532b_frontenddevelopment-internship-offerletter-activity-7370730067297218560-4s5V?utm_source=share&utm_medium=member_android&rcm=ACoAAFMxwikBDZbcDjTeGXFxMDw5NT2YysEeCcQ"> <FaLink/> Click Here  </a>
            </div>
          </div>

          <div className="box">
            <img src={workTwo} alt="secondWork" loading='lazy'/>
            <div className="content">
              <h3> Projects</h3>
              <p> personal expense tracker </p>
              <a href="https://github.com/sureka1234/personal-expense-tracker-project"> <FaLink/> Click Here </a>
              <p>Ecom-ice-cream-website-project</p>
              <a href="https://sureka1234.github.io/ecom-ice-website-project/"> <FaLink/> Click Here </a>



            </div>
          </div>

          {/* <div className="box">
            <img src={workThree} alt="thirdWork" loading='lazy'/>
            <div className="content">
              <h3> Project 03 </h3>
              <p>Student Management System | CRUD Operations With Export Functionality.  </p>
              <a href="https://www.linkedin.com/posts/naveen-fullstackdeveloper_webdevelopment-frontend-react-activity-7253644491734016000-zW0R?utm_source=share&utm_medium=member_desktop"> <FaLink/> Click Here</a>
            </div>
          </div>

          <div className="box">
            <img src={workFour} alt="fourthWork" loading='lazy'/>
            <div className="content">
              <h3> Project 04 </h3>
              <p>Web Design Project | Theme Change For Dark and Light </p>
              <a href="https://www.linkedin.com/posts/naveen-fullstackdeveloper_webdesign-react-glassmorphism-activity-7253639168612802561-cNri?utm_source=share&utm_medium=member_desktop"> <FaLink/> Click Here </a>
            </div>
          </div> */}
        </div>
        <div className="loadingBtn">
        <a href="https://www.linkedin.com/in/sureka-kumar-26153532b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" className="btnLoading"> Read More <span> <FaRedo className="downloadBtnIcon"/> </span> </a>
        </div>
      </section>
    </>
  )
}

export default Portfolio